function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.57357 5.99953L0.295119 1.72108C-0.0987167 1.32725 -0.0987167 0.688713 0.295119 0.294934C0.688955 -0.0989024 1.32743 -0.0989024 1.72127 0.294934L5.99977 4.57344L10.2783 0.294877C10.6721 -0.0989588 11.3106 -0.0989588 11.7044 0.294877C12.0982 0.688713 12.0982 1.32725 11.7044 1.72103L7.42592 5.99947L11.7044 10.278C12.0982 10.6718 12.0982 11.3103 11.7044 11.7041C11.3106 12.098 10.6721 12.098 10.2783 11.7041L5.99977 7.42562L1.72127 11.7041C1.32749 12.098 0.688955 12.098 0.295119 11.7041C-0.0987167 11.3103 -0.0987167 10.6718 0.295119 10.278L4.57357 5.99953Z"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#3C4E64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.d74f5b38.svg";
export { ForwardRef as ReactComponent };